module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collisions-page-title",
    class: [{
      'map-filter-active': _vm.mapFilterActive
    }]
  }, [_c('h1', {
    staticClass: "fetch",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [(_vm.hasResults) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.collisionsTotalFormatted))]), _vm._v(" collisions between\n      "), _c('span', [_vm._v(_vm._s(_vm.startDate))]), _vm._v(" and "), _c('span', [_vm._v(_vm._s(_vm.endDate))]), _vm._v("\n      in "), (_vm.mapFilterActive) ? _c('em', [_vm._v("map area")]) : _c('em', [_vm._v("all of Seattle")])]) : _c('div', [_vm._v("No collisions found matching those filters.")])]), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-wrap center",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('LoaderDots')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8236350a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/collisions/PageTitle.vue
// module id = 479
// module chunks = 1